var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnicorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ring-logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 86.69 86.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 6.17,
    y1: 54.34,
    x2: 78.28,
    y2: 54.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f15266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#bc74ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1abee9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 59.26,
    y1: 20.49,
    x2: 92.87,
    y2: 20.49,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.27,90.41a36.07,36.07,0,1,1,36-36.21A36,36,0,0,1,42.27,90.41ZM16,54.38c-.22,14.07,11.52,26,25.82,26.2A26.25,26.25,0,1,0,16,54.38Z",
    transform: "translate(-6.17 -3.72)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.26,10.33l6.89-6.61L92.87,30.5l-7,6.75Z",
    transform: "translate(-6.17 -3.72)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnicorn);
export default __webpack_public_path__ + "static/media/unicorn.83ed03f9d4577e1b7e9628740201b25b.svg";
export { ForwardRef as ReactComponent };